/* ============================================================
   CHIANG KONG — storefront interactions
   Sticky nav · scroll reveal · tactile parallax ·
   before-after compare · mobile menu
   ============================================================
   2026-07-02: SG/MY fake client-side currency toggle RETIRED.
   Currency is now driven by native Shopify Markets — the header
   country selector posts to /localization to switch the active
   market, presentment currency, and checkout currency for real.
   applyRegion() kept as a no-op shim in case any third-party
   code or legacy section still calls it; it no longer swaps
   price text or sets localStorage.
   ============================================================ */
(function () {
  'use strict';
  window.__ckReady = true;
  const root = document.body;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Region / currency (RETIRED — native Markets now handles this) ----------
     The region buttons in the header now submit Shopify's {% form 'localization' %},
     which POSTs to /localization and triggers a real market switch on reload.
     These shims keep any legacy callers safe; they are no-ops.
  -------------------------------------------------------------------------- */
  function applyRegion() { /* no-op: currency driven by Shopify Markets */ }
  window.ckApplyRegion = applyRegion;
  window.ckRegion = function () {
    /* Returns the active market country code from the active region button
       if one is present, or 'sg' as a safe default. */
    const active = document.querySelector('.region__btn.is-active');
    return active ? (active.getAttribute('data-region') || 'sg') : 'sg';
  };

  /* ---------- Market switch: optimistic feedback ----------
     Switching country is a native form POST → 302 → full page load, so nothing
     can repaint for ~0.5-1s (longer on media-heavy pages). Measured on 4G:
     ~550ms to the 302, ~650-900ms to first paint. Without feedback the toggle
     looks inert for that whole window and reads as broken, so the moment it is
     tapped we slide the pill to the chosen market, lock the control against a
     second tap, and run a thin progress bar across the top of the page.

     This changes nothing about the request — it only stops the wait from
     looking like a hang. State is cleared on bfcache restore (Back button)
     and by a safety timeout, so a cancelled navigation can't leave the toggle
     stuck dimmed.
  -------------------------------------------------------------------------- */
  (function marketSwitchFeedback() {
    let busy = false;
    let releaseTimer = null;

    function progressBar() {
      let el = document.getElementById('ckSwitchBar');
      if (!el) {
        el = document.createElement('div');
        el.id = 'ckSwitchBar';
        el.className = 'ck-switchbar';
        el.setAttribute('aria-hidden', 'true');
        document.body.appendChild(el);
      }
      return el;
    }

    function groups() {
      return document.querySelectorAll('.region, .mnav__region');
    }

    function release() {
      busy = false;
      clearTimeout(releaseTimer);
      Array.prototype.forEach.call(groups(), function (g) { g.classList.remove('is-switching'); });
      const bar = document.getElementById('ckSwitchBar');
      if (bar) bar.classList.remove('is-running');
    }

    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form || !form.classList) return;
      const isRegion = form.classList.contains('region') || !!(form.closest && form.closest('.mnav__region'));
      if (!isRegion) return;

      // Which market was chosen: the submit button's value on the header pill
      // (one form, two buttons), or the hidden field in the drawer (one form
      // per market). e.submitter is unavailable in older Safari — fall back.
      const submitter = e.submitter
        || (document.activeElement && document.activeElement.form === form ? document.activeElement : null);
      let iso = (submitter && submitter.value) || '';
      if (iso.length !== 2) {
        const hidden = form.querySelector('input[name="country_code"]');
        iso = hidden ? hidden.value : '';
      }
      if (!iso) return;
      const region = iso.toLowerCase();

      // Flip BOTH toggles (header pill + drawer) so whichever one is on screen
      // reacts instantly. The pill slide itself is pure CSS off .is-active.
      const btns = document.querySelectorAll('.region__btn, .mnav__region button');
      Array.prototype.forEach.call(btns, function (b) {
        const on = b.getAttribute('data-region') === region;
        b.classList.toggle('is-active', on);
        if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      Array.prototype.forEach.call(groups(), function (g) { g.classList.add('is-switching'); });

      if (busy) return;
      busy = true;
      const bar = progressBar();
      void bar.offsetWidth;               // commit the reset before animating
      bar.classList.add('is-running');
      releaseTimer = setTimeout(release, 12000);
    }, true);

    // Back/forward from bfcache restores the DOM as it was — including the
    // locked, dimmed toggle. Reset it or the switcher looks broken.
    window.addEventListener('pageshow', function (e) { if (e.persisted) release(); });
  })();

  /* ---------- Sticky nav: collapse announcement bar on scroll ---------- */
  const navwrap = document.getElementById('navwrap');

  /* ---------- Auto-hide nav on scroll pause ----------
     While the customer scrolls, the header stays visible. When scrolling stops
     for 5s the header slides up out of view; the next scroll slides it back in.
     Never hides while at the very top of the page, or while a menu / drawer /
     store popover is open. Runs on mobile, tablet + desktop, every page. */
  const NAV_TOP_THRESHOLD = 40;   // px — treat as "at the top", never hide here
  const NAV_HIDE_DELAY = 5000;    // ms of no scrolling before we hide
  let navHideTimer = null;

  function navMenuBusy() {
    // Don't hide while the mobile drawer (locks body scroll), the Shop
    // mega-menu, or the store-status popover is open.
    return document.body.style.overflow === 'hidden'
      || !!document.querySelector('#navShop.open')
      || !!document.querySelector('.storestat.is-open')
      || !!document.querySelector('.ck-header__acct[data-open="true"]');
  }
  function showNav() {
    if (navwrap) navwrap.classList.remove('ck-nav-hidden');
  }
  function scheduleNavHide() {
    clearTimeout(navHideTimer);
    navHideTimer = setTimeout(function () {
      if (!navwrap) return;
      if (window.scrollY <= NAV_TOP_THRESHOLD) return; // at top → stay visible
      if (navMenuBusy()) return;                       // a menu is open → stay
      navwrap.classList.add('ck-nav-hidden');
    }, NAV_HIDE_DELAY);
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (navwrap) navwrap.classList.toggle('compact', window.scrollY > 40);
        // Auto-hide: any scroll shows the header; pausing (or reaching the top)
        // decides whether it hides.
        showNav();
        if (window.scrollY > NAV_TOP_THRESHOLD) scheduleNavHide();
        else clearTimeout(navHideTimer);
        parallax();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Shop mega-menu ---------- */
  (function () {
    const shop = document.getElementById('navShop');
    const trigger = document.getElementById('shopTrigger');
    const mega = document.getElementById('mega');
    const scrim = document.getElementById('megaScrim');
    if (!shop || !mega || !scrim) return;
    mega.hidden = false; scrim.hidden = false;
    let closeT, pinT;
    // Touch state for the trigger click (see the click handler below).
    let tappedOpen = false, byTouch = false;
    function open() {
      clearTimeout(closeT); clearTimeout(pinT);
      shop.classList.add('open'); mega.classList.add('open'); scrim.classList.add('show');
      trigger.setAttribute('aria-expanded', 'true');
      mega.style.transition = ''; mega.style.opacity = '1'; mega.style.transform = 'none';
      pinT = setTimeout(function () { mega.style.transition = 'none'; mega.style.opacity = '1'; mega.style.transform = 'none'; }, 320);
    }
    function close() {
      clearTimeout(pinT); tappedOpen = false;
      shop.classList.remove('open'); mega.classList.remove('open'); scrim.classList.remove('show');
      trigger.setAttribute('aria-expanded', 'false');
      mega.style.transition = 'none'; mega.style.opacity = '0'; mega.style.transform = 'translateY(-12px)';
    }
    function delayedClose() { clearTimeout(closeT); closeT = setTimeout(close, 140); }
    shop.addEventListener('mouseenter', open);
    mega.addEventListener('mouseenter', open);
    shop.addEventListener('mouseleave', delayedClose);
    mega.addEventListener('mouseleave', delayedClose);

    // Keyboard: tabbing onto the trigger (or into the panel) opens it, so the
    // mega links are reachable without a mouse. Enter still follows the link.
    shop.addEventListener('focusin', open);
    mega.addEventListener('focusin', open);
    shop.addEventListener('focusout', delayedClose);
    mega.addEventListener('focusout', delayedClose);

    // The trigger is a real link to the shop page (#brands). With a mouse the
    // panel is already open on hover, so the click simply follows the link.
    // Touch has no hover to peek with — and tapping fires a synthetic
    // mouseenter, so we can't just test .open — therefore the FIRST tap opens
    // the panel and the second follows the link. close() clears tappedOpen.
    trigger.addEventListener('pointerdown', function (e) {
      byTouch = e.pointerType ? e.pointerType !== 'mouse' : false;
    });
    trigger.addEventListener('click', function (e) {
      if (byTouch && !tappedOpen) { e.preventDefault(); tappedOpen = true; open(); }
    });
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    mega.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  })();

  /* ---------- Scroll reveal ---------- */
  const revealEls = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));

  // Add .in (plays the CSS entrance animation), then pin visible inline once the
  // animation should be done. The pin is a no-op for users whose animation ran
  // (already opacity:1) but guarantees visibility if the engine paused/froze it.
  function reveal(el) {
    if (el.classList.contains('in')) return;
    el.classList.add('in');
    const d = parseFloat(getComputedStyle(el).getPropertyValue('--d')) || 0;
    // After the entrance animation should have finished, pin the element visible
    // by REMOVING the animation (a frozen animation outranks inline styles, so we
    // must clear it, not just override). No-op for users whose animation ran.
    setTimeout(function () {
      el.style.animation = 'none';
      el.style.opacity = '1';
      el.style.transform = 'none';
    }, 1150 + d);
  }

  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('in'); el.style.animation = 'none'; el.style.opacity = '1'; el.style.transform = 'none'; });
  } else {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });

    // Reveal anything already in view immediately on load (no blank above-the-fold)
    function revealInView() {
      const vh = window.innerHeight || 800;
      revealEls.forEach(function (el) {
        if (el.classList.contains('in')) return;
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) reveal(el);
      });
    }
    revealInView();
    window.requestAnimationFrame(revealInView);
    window.addEventListener('load', revealInView);
    // Fallback: reveal on scroll/resize too, in case the IntersectionObserver doesn't fire
    window.addEventListener('scroll', revealInView, { passive: true });
    window.addEventListener('resize', revealInView, { passive: true });
    // Deterministic safety net: in environments where the page never scrolls and the
    // IntersectionObserver never fires, reveal everything still hidden so nothing can
    // stay blank. Real users who scroll sooner get the per-section reveal first.
    setTimeout(function () { revealEls.forEach(reveal); }, 1300);

    // quote band river draw
    const qb = document.querySelector('.quoteband');
    if (qb) {
      const io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in-view'); io2.unobserve(en.target); }
        });
      }, { threshold: 0.3 });
      io2.observe(qb);
    }
  }

  /* ---------- Tactile parallax ---------- */
  const parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  function parallax() {
    if (reduce) return;
    const vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      const r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const speed = parseFloat(el.getAttribute('data-parallax')) || 0;
      const center = r.top + r.height / 2;
      const frac = (center - vh / 2) / vh; // -0.5..0.5
      el.style.transform = 'translate3d(0,' + (frac * speed).toFixed(2) + 'px,0)';
    });
  }
  parallax();
  window.addEventListener('resize', parallax, { passive: true });

  /* ---------- Before / After compare ---------- */
  (function () {
    const compare = document.getElementById('baCompare');
    if (!compare) return;
    const before = document.getElementById('baBefore');
    const handle = document.getElementById('baHandle');
    let dragging = false, userTouched = false;
    function set(clientX) {
      const r = compare.getBoundingClientRect();
      let p = (clientX - r.left) / r.width;
      p = Math.max(0.04, Math.min(0.96, p));
      const pct = (p * 100).toFixed(1);
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    function down(e) {
      dragging = true; userTouched = true;
      compare.classList.add('is-dragging');
      set(e.clientX);
      if (e.pointerId != null && compare.setPointerCapture) { try { compare.setPointerCapture(e.pointerId); } catch (_) {} }
      e.preventDefault();
    }
    function move(e) { if (dragging) { set(e.clientX); e.preventDefault(); } }
    function up() { dragging = false; compare.classList.remove('is-dragging'); }
    compare.addEventListener('pointerdown', down);
    compare.addEventListener('pointermove', move);
    compare.addEventListener('pointerup', up);
    compare.addEventListener('pointercancel', up);
    compare.addEventListener('lostpointercapture', up);
    // keyboard support
    compare.setAttribute('tabindex', '0');
    compare.addEventListener('keydown', function (e) {
      const cur = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') { userTouched = true; set(compare.getBoundingClientRect().left + compare.offsetWidth * (cur - 4) / 100); e.preventDefault(); }
      if (e.key === 'ArrowRight') { userTouched = true; set(compare.getBoundingClientRect().left + compare.offsetWidth * (cur + 4) / 100); e.preventDefault(); }
    });
    // gentle auto hint on first view (stops the moment the user interacts)
    if (!reduce && 'IntersectionObserver' in window) {
      const hint = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          hint.unobserve(en.target);
          let t = 0;
          const seq = [62, 40, 50];
          (function step() {
            if (userTouched || t >= seq.length) return;
            const pct = seq[t];
            before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
            handle.style.left = pct + '%';
            t++; setTimeout(step, 520);
          })();
        });
      }, { threshold: 0.5 });
      hint.observe(compare);
    }
  })();

  /* ---------- Mobile menu ----------
     I1 2026-07-02: full accessibility overhaul.
     - Links driven from the #ck-nav-data JSON island (mirrors desktop linklist + shop blocks)
     - role="dialog" + aria-modal on the panel
     - aria-expanded on the burger (synced open/close)
     - aria-expanded on the Shop accordion toggle
     - Focus management: focus close-btn on open, restore burger on close
     - Focus trap: Tab/Shift+Tab cycles within the panel's focusable elements
     - Escape-to-close
  */
  (function () {
    var burger = document.querySelector('.nav__burger');
    if (!burger) return;

    /* \u2500\u2500 Read nav data from Liquid island \u2500\u2500 */
    var navData = { links: [], lumiere_url: '/collections/lumiere', lumiere_name: 'Lumi\u00e8re' };
    try {
      var dataEl = document.getElementById('ck-nav-data');
      if (dataEl) navData = JSON.parse(dataEl.textContent);
    } catch (_) {}

    /* Drawer UI strings: ck-header renders them already translated into
       navData.labels; ckT() (locale keys) is the fallback when the island
       predates them. */
    var L = navData.labels || {};
    function label(k, key, en, vars) { return L[k] || ckT(key, en, vars); }
    var LR = L.regions || {};

    /* \u2500\u2500 Build inner HTML from nav data \u2500\u2500 */
    function buildLinks(links) {
      var html = '';
      links.forEach(function (link) {
        if (link.children && link.children.length) {
          html += '<button class="mnav__acc" type="button" aria-expanded="false">' + link.title + ' <span aria-hidden="true">\u25be</span></button>';
          // Children may include {heading} group labels (Shop: "Shop by type" /
          // "Brands we carry"), so the sub-panel is a plain group of links
          // rather than an ARIA list, which may only own listitems.
          html += '<div class="mnav__sub">';
          link.children.forEach(function (child) {
            if (child.heading) {
              html += '<span class="mnav__subhead">' + child.heading + '</span>';
            } else {
              html += '<a href="' + child.url + '"' + (child.more ? ' class="mnav__submore"' : '') + '>' + child.title + '</a>';
            }
          });
          html += '</div>';
        } else {
          html += '<a href="' + link.url + '">' + link.title + '</a>';
        }
      });
      return html;
    }

    /* \u2500\u2500 Market region selector \u2500\u2500 */
    function buildRegion() {
      // Mirror the native {% form 'localization' %} the desktop header renders.
      // That endpoint is a Rails PUT reached via a "_method=put" override field;
      // without it a plain POST to /localization 404s (this is why the mobile
      // toggle broke while desktop worked). Read the real action off the source
      // form too, so we stay correct if Shopify ever prefixes it (locale root).
      var srcForm = document.querySelector('form.region');
      var regionAction = (srcForm && srcForm.getAttribute('action')) || '/localization';
      var activeBtn = document.querySelector('.region__btn.is-active');
      var activeIso = activeBtn ? (activeBtn.getAttribute('data-region') || 'sg').toUpperCase() : 'SG';
      var countries = [
        { iso: 'SG', name: (LR.sg && LR.sg.name) || ckT('ui.region.singapore', 'Singapore'), aria: LR.sg && LR.sg.aria, currency: 'S$' },
        { iso: 'MY', name: (LR.my && LR.my.name) || ckT('ui.region.malaysia', 'Malaysia'), aria: LR.my && LR.my.aria, currency: 'RM' }
      ];

      // The flag artwork is authored once, in snippets/ck-flag.liquid, and
      // rendered by the desktop toggle \u2014 which stays in the DOM at every
      // width (it is only display:none on small screens). Clone it here rather
      // than keeping a second copy of the SVG in JS, so the two toggles cannot
      // drift. Falls back to the name alone if the header markup is absent.
      function flagFor(iso) {
        var src = document.querySelector('.region__btn[data-region="' + iso.toLowerCase() + '"] .ck-flag');
        return src ? src.outerHTML : '';
      }

      return '<div class="mnav__region">' +
        countries.map(function (c) {
          var isActive = c.iso === activeIso;
          return '<form method="post" action="' + regionAction + '" accept-charset="UTF-8">' +
            '<input type="hidden" name="form_type" value="localization">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="_method" value="put">' +
            '<input type="hidden" name="country_code" value="' + c.iso + '">' +
            '<input type="hidden" name="return_to" value="' + (window.location.pathname + window.location.search) + '">' +
            '<button type="submit" data-region="' + c.iso.toLowerCase() + '"' +
              (isActive ? ' class="is-active"' : '') +
              ' aria-pressed="' + (isActive ? 'true' : 'false') + '"' +
              ' aria-label="' + esc(c.aria || ckT('ui.region.shop_in', 'Shop in {name}, prices in {currency}', { name: c.name, currency: c.currency })) + '">' +
              flagFor(c.iso) +
              '<span class="mnav__region-name">' + esc(c.name) + '</span>' +
            '</button>' +
            '</form>';
        }).join('') +
        '</div>';
    }

    /* \u2500\u2500 Language selector \u2500\u2500
       Shown only when the store offers more than one language (navData.languages,
       rendered by ck-header). Prefer cloning the header's real
       {% form 'localization' %} (form[data-ck-lang-form]) so the action, the
       form_type/utf8 fields and the "_method=put" override stay exactly what
       Shopify emitted \u2014 a plain POST to /localization without _method=put
       404s (the bug the market row once had). ck-header's delegated click
       listener on [data-ck-lang] fills language_code before the native submit.
       If the header form is absent, build an equivalent form by hand, using
       named submit buttons so it still works without that listener. */
    function buildLanguage() {
      var langs = navData.languages || [];
      if (!langs.length || langs.length < 2) return '';
      var returnTo = window.location.pathname + window.location.search;
      var aria = label('language_aria', 'ui.lang.choose', 'Choose language');
      function langFor(iso) {
        return langs.filter(function (x) { return x.iso_code === iso; })[0];
      }
      function display(l) { return l.name || l.label || l.iso_code; }

      var src = document.querySelector('form[data-ck-lang-form]');
      if (src) {
        var form = src.cloneNode(true);
        form.className = 'mnav__lang';
        form.removeAttribute('id');
        form.setAttribute('role', 'group');
        form.setAttribute('aria-label', aria);
        // Belt and braces: the endpoint needs these, whatever the source emitted.
        if (!form.querySelector('input[name="_method"]')) {
          form.insertAdjacentHTML('afterbegin', '<input type="hidden" name="_method" value="put">');
        }
        if (!form.querySelector('input[name="return_to"]')) {
          form.insertAdjacentHTML('afterbegin', '<input type="hidden" name="return_to" value="' + esc(returnTo) + '">');
        }
        Array.prototype.forEach.call(form.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
        Array.prototype.forEach.call(form.querySelectorAll('.ck-lang__btn, [data-ck-lang]'), function (b) {
          var l = langFor(b.getAttribute('data-ck-lang'));
          b.className = l && l.active ? 'is-active' : '';
          if (l) {
            b.textContent = display(l);
            b.setAttribute('aria-pressed', l.active ? 'true' : 'false');
          }
        });
        return form.outerHTML;
      }

      var action = '/localization';
      var anyLoc = document.querySelector('form.region');
      if (anyLoc && anyLoc.getAttribute('action')) action = anyLoc.getAttribute('action');
      return '<form method="post" action="' + esc(action) + '" accept-charset="UTF-8" class="mnav__lang" role="group" aria-label="' + esc(aria) + '">' +
        '<input type="hidden" name="form_type" value="localization">' +
        '<input type="hidden" name="utf8" value="\u2713">' +
        '<input type="hidden" name="_method" value="put">' +
        '<input type="hidden" name="return_to" value="' + esc(returnTo) + '">' +
        langs.map(function (l) {
          return '<button type="submit" name="language_code" value="' + esc(l.iso_code) + '"' +
            (l.active ? ' class="is-active"' : '') +
            ' lang="' + esc(l.iso_code) + '"' +
            ' aria-pressed="' + (l.active ? 'true' : 'false') + '">' +
            esc(display(l)) +
          '</button>';
        }).join('') +
        '</form>';
    }

    /* \u2500\u2500 Account block \u2500\u2500
       The header's avatar + menu is desktop-only (it is display:none under the
       burger breakpoint), so the drawer carries the same information: who you
       are signed in as, a link to the account, and the way out. Only Liquid can
       see the customer, so ck-header renders the facts into #ck-nav-data and
       this just lays them out. */
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function buildAccount() {
      var a = navData.account;
      if (!a || !a.show) return '';

      if (!a.logged_in) {
        return '<div class="mnav__account mnav__account--guest">' +
          '<a class="mnav__account-link" href="' + esc(a.login_url || '/account/login') + '">' + esc(label('log_in', 'ui.account.log_in', 'Log in')) + '</a>' +
          '</div>';
      }

      return '<div class="mnav__account">' +
        '<div class="mnav__account-id">' +
          '<span class="mnav__account-avatar" aria-hidden="true">' + esc(a.initials) + '</span>' +
          '<span class="mnav__account-who">' +
            '<span class="mnav__account-hint">' + esc(label('signed_in_as', 'ui.account.signed_in_as', 'Signed in as')) + '</span>' +
            '<span class="mnav__account-name">' + esc(a.name) + '</span>' +
          '</span>' +
        '</div>' +
        buildStaffAirlines(a.airline_staff) +
        '<a class="mnav__account-link" href="' + esc(a.account_url || '/account') + '">' + esc(label('my_account_orders', 'ui.account.account_orders', 'My account & orders')) + '</a>' +
        '<a class="mnav__account-link mnav__account-link--out" href="' + esc(a.logout_url || '/account/logout') + '">' + esc(label('log_out', 'ui.account.log_out', 'Log out')) + '</a>' +
        '</div>';
    }

    /* ── Airline staff shortcut ──
       Mirrors the tinted row in the desktop account menu. The list is resolved
       in Liquid (snippets/ck-staff-airline-links.liquid) because only Liquid can
       see both the customer and the airline metaobjects, so this only lays out
       what ck-header already decided this customer is entitled to. Empty for
       everyone who is not airline staff. */
    function buildStaffAirlines(list) {
      if (!list || !list.length) return '';

      return list.map(function (al) {
        var logo = al.logo
          ? '<img class="mnav__staff-logo" src="' + esc(al.logo) + '" alt="" loading="lazy" width="34" height="34" aria-hidden="true">'
          : '<span class="mnav__staff-logo mnav__staff-logo--mono" aria-hidden="true">' +
              esc(String(al.name || 'A').charAt(0).toUpperCase()) +
            '</span>';

        return '<a class="mnav__account-link mnav__staff" href="' + esc(al.url) + '">' +
          logo +
          '<span class="mnav__staff-text">' +
            '<span class="mnav__staff-name">' + esc(al.label || al.name) + '</span>' +
            (al.note ? '<span class="mnav__staff-note">' + esc(al.note) + '</span>' : '') +
          '</span>' +
          '</a>';
      }).join('');
    }

    /* \u2500\u2500 Create drawer DOM \u2500\u2500 */
    var mnav = document.createElement('div');
    mnav.className = 'mnav';
    mnav.innerHTML =
      '<div class="mnav__scrim" aria-hidden="true"></div>' +
      '<div id="ckMobileNav" class="mnav__panel" role="dialog" aria-modal="true" aria-label="' + esc(label('drawer_aria', 'ui.nav.navigation', 'Navigation')) + '">' +
        '<button class="mnav__close" aria-label="' + esc(label('close_aria', 'ui.nav.close', 'Close navigation')) + '">\u00d7</button>' +
        buildLinks(navData.links) +
        buildAccount() +
        buildRegion() +
        buildLanguage() +
      '</div>';
    document.body.appendChild(mnav);

    var panelEl   = mnav.querySelector('.mnav__panel');
    var closeBtn  = mnav.querySelector('.mnav__close');
    var scrim     = mnav.querySelector('.mnav__scrim');
    var accs      = mnav.querySelectorAll('.mnav__acc');

    /* \u2500\u2500 Focus trap helpers \u2500\u2500 */
    function getFocusable() {
      return Array.prototype.slice.call(
        panelEl.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return !el.closest('.mnav__sub:not(.open)'); });
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    }

    /* \u2500\u2500 Open / close \u2500\u2500 */
    function openDrawer() {
      mnav.classList.add('open');
      panelEl.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', label('close_aria', 'ui.nav.close', 'Close navigation'));
      /* Move focus into the panel */
      var focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      mnav.classList.remove('open');
      document.body.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', label('open_aria', 'ui.nav.open', 'Open navigation'));
      /* Restore focus to the burger */
      burger.focus();
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      trapFocus(e);
    }

    /* \u2500\u2500 Accordions (Shop + any nav link with children) \u2500\u2500 */
    Array.prototype.forEach.call(accs, function (acc) {
      var sub = acc.nextElementSibling;
      if (!sub || !sub.classList.contains('mnav__sub')) return;
      acc.addEventListener('click', function () {
        var isOpen = acc.classList.toggle('open');
        sub.classList.toggle('open', isOpen);
        acc.setAttribute('aria-expanded', String(isOpen));
      });
    });

    /* \u2500\u2500 Event bindings \u2500\u2500 */
    burger.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    mnav.querySelectorAll('.mnav__panel a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
  })();

  /* ---------- FAQ accordion ---------- */
  (function () {
    const items = document.querySelectorAll('.faqitem');
    if (!items.length) return;
    items.forEach(function (item) {
      const q = item.querySelector('.faqitem__q');
      const a = item.querySelector('.faqitem__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');
        // Close all items and reset aria-expanded
        items.forEach(function (other) {
          other.classList.remove('open');
          const oq = other.querySelector('.faqitem__q');
          const oa = other.querySelector('.faqitem__a');
          if (oq) oq.setAttribute('aria-expanded', 'false');
          if (oa) oa.style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          q.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  })();

  /* ---------- Claims voucher → replacement picker ---------- */
  (function () {
    const form = document.getElementById('voucherForm');
    if (!form) return;
    const input = document.getElementById('voucherInput');
    const error = document.getElementById('voucherError');
    const result = document.getElementById('claimResult');
    const refOut = document.getElementById('claimRef');
    const airlineOut = document.getElementById('claimAirline');
    const intro = document.getElementById('voucherIntro');

    const AIRLINES = {
      SQ: 'Singapore Airlines', TR: 'Scoot', MH: 'Malaysia Airlines',
      AK: 'AirAsia', CX: 'Cathay Pacific', EK: 'Emirates', QR: 'Qatar Airways',
      MI: 'SilkAir', OD: 'Batik Air', VZ: 'Thai Vietjet'
    };
    // Format: 2 letters - 4 digits - 4–6 alphanumerics, e.g. SQ-2024-AB12C
    const FORMAT = /^([A-Z]{2})-(\d{4})-([A-Z0-9]{4,6})$/;

    function activate(ref, airline) {
      refOut.textContent = ref;
      airlineOut.textContent = airline;
      result.hidden = false;
      // pin reveal-children visible + play their entrance
      result.querySelectorAll('[data-reveal]').forEach(function (el, i) {
        el.style.setProperty('--d', (i % 4) * 70 + 'ms');
        setTimeout(function () {
          el.classList.add('in'); el.style.animation = ''; el.style.opacity = '1'; el.style.transform = 'none';
        }, 40);
      });
      if (intro) intro.classList.add('is-validated');
      const top = result.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const raw = (input.value || '').trim().toUpperCase().replace(/\s+/g, '');
      const m = raw.match(FORMAT);
      if (!m) {
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      error.hidden = true;
      input.removeAttribute('aria-invalid');
      const airline = AIRLINES[m[1]] || ckT('ui.voucher.your_airline', 'your airline');
      activate(raw, airline);
    });

    input.addEventListener('input', function () {
      if (!error.hidden) { error.hidden = true; input.removeAttribute('aria-invalid'); }
    });

    // "Not your claim?" → reset
    const reset = document.getElementById('claimReset');
    if (reset) reset.addEventListener('click', function (e) {
      e.preventDefault();
      result.hidden = true;
      if (intro) intro.classList.remove('is-validated');
      input.value = '';
      document.querySelectorAll('.bag-card.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
      const picked = document.getElementById('pickConfirm');
      if (picked) picked.hidden = true;
      form.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      input.focus();
    });

    // Bag selection
    const confirm = document.getElementById('pickConfirm');
    const confirmName = document.getElementById('pickConfirmName');
    document.querySelectorAll('.bag-card').forEach(function (card) {
      const pick = card.querySelector('.bag-card__pick');
      if (!pick) return;
      pick.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.bag-card.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
        card.classList.add('is-picked');
        if (confirm && confirmName) {
          confirmName.textContent = card.getAttribute('data-bag') || ckT('ui.voucher.your_bag', 'your bag');
          confirm.hidden = false;
          confirm.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });
  })();

  /* ---------- Tweaks (hero variant + colour anchor) ---------- */
  window.addEventListener('message', function (e) {
    const d = e.data;
    if (!d || d.type !== 'tweak') return;
    if (d.key === 'heroVariant') {
      const hero = document.getElementById('hero');
      if (hero) hero.setAttribute('data-hero', d.value);
      requestAnimationFrame(parallax);
    }
    if (d.key === 'anchor') root.setAttribute('data-anchor', d.value);
  });
})();

